module.exports = __webpack_public_path__ + "img/passo-1.10ccdb40.png";